<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm
            ref="formUploadSimpleFilterFile"
            @submit="formSubmit($event, 'uploadSimpleFilterFile')"
        >
            <CContainer class="mb-3 mt-2">
                <CRow>
                    <CCol class="d-flex">
                        <CSelect
                            :options="[
                                {
                                    value: 'csv',
                                    label: $t('csv'),
                                },
                            ]"
                            :label="$t('format')"
                            :horizontal="{
                                label: 'col-sm-4',
                                input: 'col-sm-6',
                            }"
                            :placeholder="$t('Select a format')"
                            size="sm"
                            :isValid="
                                checkIfFormValid({
                                    formName: 'uploadSimpleFilterFile',
                                    fieldName: 'format',
                                })
                            "
                            :value.sync="$v.forms.uploadSimpleFilterFile.format.$model"
                        />
                        <CSelect
                            :options="[
                                {
                                    value: ',',
                                    label: ',',
                                },
                                {
                                    value: ';',
                                    label: ';',
                                },
                                {
                                    value: ' ',
                                    label: $t('space'),
                                },
                            ]"
                            :label="$t('delimiter')"
                            :placeholder="$t('Select a delimiter')"
                            :horizontal="{
                                label: 'col-sm-4',
                                input: 'col-sm-6',
                            }"
                            size="sm"
                            :isValid="
                                checkIfFormValid({
                                    formName: 'uploadSimpleFilterFile',
                                    fieldName: 'delimiter',
                                })
                            "
                            :value.sync="
                                $v.forms.uploadSimpleFilterFile.delimiter.$model
                            "
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol class="d-flex mt-2">
                        <CSelect
                            :label="$t('End line')"
                            :placeholder="$t('Select a end line')"
                            :options="[
                                {
                                    value: '\\n',
                                    label: '\\n',
                                },
                                {
                                    value: '\\r',
                                    label: '\\r',
                                },
                                {
                                    value: '\\r\\n',
                                    label: '\\r\\n',
                                },
                            ]"
                            :horizontal="{
                                label: 'col-sm-4',
                                input: 'col-sm-6',
                            }"
                            size="sm"
                            :isValid="
                                checkIfFormValid({
                                    formName: 'uploadSimpleFilterFile',
                                    fieldName: 'endLine',
                                })
                            "
                            :value.sync="
                                $v.forms.uploadSimpleFilterFile.endLine.$model
                            "
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol class="mt-3">
                        <p>Select a file to upload:</p>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="12">
                        <div class="d-flex justify-content-center">
                            <CCButtonUploadFile
                                ref="inputUploadFile"
                                uploadType="simple-filter-file"
                                @change="uploadFile"
                            >
                            </CCButtonUploadFile>
                        </div>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol class="mt-3">
                        <CCTable
                            :items="tables.allowedFieldsConfiguration.items"
                            :fields="tables.allowedFieldsConfiguration.fields"
                            :resizable="false"
                        >
                            <template #file_fields="{ item }">
                                <SelectAsync
                                    :options="headers"
                                    :value.sync="item.file_fields"
                                    :placeholder="$t('Select a field to map')"
                                    size="sm"
                                />
                            </template>
                        </CCTable>
                    </CCol>
                </CRow>
            </CContainer>

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.uploadSimpleFilterFile._loading"
            >
                <span>{{ $t("upload") }}</span>
            </ButtonLoading>
        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading
                color="primary"
                @click="executeSubmitForm"
                :loading="forms.uploadSimpleFilterFile._loading"
            >
                {{ $t("upload") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
import formMixin from "~/mixins/form";
import modalComponentMixin from "~/mixins/modalComponent";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import ButtonLoading from "~/components/ButtonLoading.vue";
import CCTable from "~/components/CCTable";
import SelectAsync from "£lement/SelectAsync";
import CCButtonUploadFile from "~/components/CCButtonUploadFile";
import { showLineBreaksAsText } from "../utils";

export default {
    name: "CCModalUploadSimpleFilterFile",
    mixins: [formMixin, validationMixin, modalComponentMixin],
    components: {
        ButtonLoading,
        CCButtonUploadFile,
        CCTable,
        SelectAsync,
    },
    data() {
        return {
            forms: {
                uploadSimpleFilterFile: {
                    delimiter: null,
                    format: "csv",
                    textDelimiter: null,
                    endLine: null,
                    _loading: false,
                },
            },
            headers: [],
            firstLine: null,
            tables: {
                allowedFieldsConfiguration: {
                    items: [
                        {
                            allowed_fields: "row_content",
                            file_fields: null,
                        },
                    ],
                    fields: [
                        {
                            key: "allowed_fields",
                            label: "Allowed fields",
                            _style: "width:20%",
                        },
                        {
                            key: "file_fields",
                            label: "File fields",
                        },
                    ],
                },
            },

            _shouldStop: false,
            _timerId: null,
        };
    },

    validations: {
        forms: {
            uploadSimpleFilterFile: {
                delimiter: {
                    required,
                },
                endLine: {
                    required,
                },
                format:{
                    required
                }
            },
        },
    },

    watch: {
        show() {
            this.showComponent = this.show;
            if (!this.show) {
                this.resetForm("uploadSimpleFilterFile");
                this.$v.$reset();

                this.cancelCheckProcessedFileUntilDone();
            }
        },
        "forms.uploadSimpleFilterFile.delimiter": {
            handler: function (newValue) {
                if (this.firstLine) {
                    this.firstLine = this.firstLine.replace(this.forms.uploadSimpleFilterFile.endLine, "");
                    this.headers = this.firstLine.split(newValue);
                }
            },
            deep: true,
        },
        "forms.uploadSimpleFilterFile.endLine": {
            handler: function (newValue) {
                if (this.firstLine) {
                    this.firstLine = this.firstLine.replace(newValue, "");
                    this.headers = this.firstLine.split(this.forms.uploadSimpleFilterFile.delimiter);
                }
            },
            deep: true,
        },
    },

    methods: {
        async uploadFile(e) {
            this.firstLine = e.firstLine;
            this.firstLine = showLineBreaksAsText(this.firstLine);
            this.firstLine = this.firstLine.replace(this.forms.uploadSimpleFilterFile.endLine, "");
            this.headers = this.firstLine.split(
                this.forms.uploadSimpleFilterFile.delimiter
            );
        },
        async formSubmit(e, formName) {
            e.preventDefault();
            try {

                if (this.isInvalidForm(formName)) {
                    throw new Error("Invalid data");
                };

                this.forms.uploadSimpleFilterFile._loading = true;
                const refInputUploadFile = this.$refs["inputUploadFile"];
                const { key, fileName } = await refInputUploadFile.saveFile();

                let mappingFields = {};
                for (
                    let i = 0;
                    i < this.tables.allowedFieldsConfiguration.items.length;
                    i++
                ) {
                    const item =
                        this.tables.allowedFieldsConfiguration.items[i];

                    mappingFields = {
                        ...mappingFields,
                        [item.allowed_fields]: item.file_fields
                            ? item.file_fields
                            : null,
                    };
                }

                await this.fetcher({
                    baseURL: process.env.VUE_APP_API_SASS,
                    // baseURL: process.env.VUE_APP_API_SASS_OFFLINE,
                    url: `/imports/simple-filter-files/${key}/process`,
                    method: "POST",
                    data: {
                        fileName,
                        delimiter: this.forms.uploadSimpleFilterFile.delimiter,
                        allowedFieldsMapping: mappingFields,
                        key,
                    },
                });

                await this.checkProcessedFileUntilDone(key, 15000, 600000 * 5);

                this.$emit("uploadedFile", { key, fileName });

                this.forms.uploadSimpleFilterFile._loading = false;
                this.showComponent = false;
                this.showMessageSuccess();
            } catch (error) {
                this.showMessageError(error);
            }

            this.$emit("submit", formName);
        },

        checkProcessedFileUntilDone(key, delay = 10000, timeout = 0) {
            this._shouldStop = false;
            let elapsed = 0;

            return new Promise((resolve, reject) => {
                const check = async () => {
                    // 1) Si nos han pedido parar, rechazamos
                    if (this._shouldStop) {
                        return reject(new Error("Polling cancel by the user"));
                    }

                    try {
                        const { data } = await this.fetcher({
                            baseURL: process.env.VUE_APP_API_SASS,
                            // baseURL: process.env.VUE_APP_API_SASS_OFFLINE,
                            url: `/imports/simple-filter-files/${key}`,
                            method: "GET",
                        });

                        const status = data.status?.toLowerCase();
                        if (status === "processed") {
                            return resolve(data);
                        }
                        if (status === "error") {
                            return reject(new Error("Error on upload file"));
                        }
                        if (timeout > 0 && elapsed + delay > timeout) {
                            return reject(new Error("Upload file timeout"));
                        }

                        // 2) Programamos siguiente chequeo
                        elapsed += delay;
                        this._timerId = setTimeout(check, delay);
                    } catch (err) {
                        return reject(err);
                    }
                };

                // Primera llamada inmediata
                check();
            });
        },

        cancelCheckProcessedFileUntilDone() {
            this._shouldStop = true;
            clearTimeout(this._timerId);
            this._timerId = null;
        },

        executeSubmitForm() {
            this.$refs.formAddLang.requestSubmit();
        },
    },
};
</script>

<style></style>
